import {
  Dialog, DialogTitle, DialogContent, DialogActions,
} from '@mui/material';
import { ModalBackButton, ModalContinueButton } from '../buttons';

export const CommonModal = ({
  open,
  title = 'modal title',
  children,
  width = '620px',
  backText = 'Cancel',
  continueText = 'Continue',
  continueDisabled = false,
  handleClose,
  handleOK,

}) => (
  <Dialog
    open={open}
    onClose={handleClose}
    sx={{
      '& .MuiPaper-root': {
        width,
      },
    }}
  >
    <DialogTitle>
      {title}
    </DialogTitle>
    <DialogContent
      dividers
      sx={{ padding: '20px' }}
    >
      {children}
    </DialogContent>
    <DialogActions
      sx={{
        padding: '16px',
      }}
    >
      <ModalBackButton
        onClick={handleClose}
        text={backText}
      />
      <ModalContinueButton
        onClick={handleOK}
        text={continueText}
        disabled={continueDisabled}
      />
    </DialogActions>
  </Dialog>
);
